/*
* @描述:
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2022-11-23 18:09:48
*/
<template>
    <el-dialog width="35%"
               v-dialog-drag
               :title="addTitle"
               :before-close="handleClickCancel"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :visible.sync="addVisible">
        <el-form size="small"
                 ref="menuForm"
                 label-position="right"
                 label-width="auto"
                 :model="menuForm"
                 :rules="menuFormRules">
            <el-form-item label="菜单名称" prop="title">
                <el-input v-model="menuForm.title" placeholder="请输入菜单名称"></el-input>
            </el-form-item>
            <el-form-item label="链接" prop="route">
                <el-input v-model="menuForm.route" placeholder="请输入链接"></el-input>
            </el-form-item>
            <el-form-item label="图标" prop="ico">
                <el-input v-model="menuForm.ico" placeholder="请输入图标"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="menuForm.sort" placeholder="请输入排序号"></el-input>
            </el-form-item>
            <el-form-item label="角色权限是否展示" prop="role_show">
                <el-switch v-model="menuForm.role_show"
                           active-text="是"
                           inactive-text="否"
                           :active-value="1"
                           :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="是否有范围数据权限" prop="role_range">
                <el-switch v-model="menuForm.role_range"
                           active-text="是"
                           inactive-text="否"
                           :active-value="1"
                           :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="是否为公共节点" prop="is_public">
                <el-switch v-model="menuForm.is_public"
                           active-text="是"
                           inactive-text="否"
                           :active-value="1"
                           :inactive-value="0">
                </el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" @click="handleClickConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import {AddMenu} from '@/api'

    export default {
        name: 'addMenu',
        props: {
            addVisible: {
                type: Boolean,
                default: false,
            },
            addTitle: {
                type: String,
                default: '',
            },
            menuPid: {
                type: Number,
                default: 0,
            },
            pid_path: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                menuForm: {
                    pid: 0,
                    title: '',
                    route: '', // admin/web/
                    ico: '',
                    sort: 0,
                    role_show: 1,
                    role_range: 1,
                    is_public: 0,
                },
                menuFormRules: {
                    title: [{
                        required: true,
                        message: '请输入菜单名称'
                    }],
                    route: [{
                        required: true,
                        message: '请输入链接'
                    }],
                }
            }
        },
        created() {
        },
        mounted() {
            if (this.menuPid !== 0) {
                this.menuForm.pid = this.menuPid
            }
        },
        methods: {
            //取消事件1
            handleClickCancel() {
                //重置表格
                this.$refs.menuForm.resetFields()
                //关闭对话框
                this.$emit('update:addVisible', false)
            },

            //确定事件
            handleClickConfirm() {
                this.$refs.menuForm.validate(valid => {
                    if (valid) {
                        // 验证通过调用新增菜单接口
                        AddMenu({
                            pid: this.menuForm.pid,
                            title: this.menuForm.title,
                            route: this.menuForm.route,
                            ico: this.menuForm.ico,
                            sort: this.menuForm.sort,
                            role_show: this.menuForm.role_show,
                            role_range: this.menuForm.role_range,
                            is_public: this.menuForm.is_public,
                            pid_path: this.pid_path,
                            menuflag: 1,
                            type: 0,
                            single: 0,
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message.success('新增成功')
                                //调用取消事件
                                this.handleClickCancel()
                                //父页面刷新列表
                                this.$emit('success')
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>
<style lang="scss" scoped>

</style>
